import { Details } from '../Details';
import { Items } from '../Items';
import { Payments } from '../Payments';
import { RefundAmounts } from '../RefundAmounts';
import { RefundItems } from '../RefundItems';
import { Rewards } from '../Rewards';
import { Status } from '../Status';
import { Totals } from '../Totals';
import { Flex } from '../../../GlobalComponents/Flex';
import { OrderFieldsFragment } from '../../../graphql';
import { centsToMoney } from '../../../utils/centsToMoney';

import styled from 'styled-components';

export type OrderProps = React.HTMLAttributes<HTMLDivElement> & {
	order: OrderFieldsFragment;
};

export const Order: React.FC<OrderProps> = ({
	order: {
		id,
		storeId,
		pickupLocation,
		timePlaced,
		pickupName,
		creditCardPayments,
		giftCardPayments,
		pointsEarned,
		status,
		time,
		items,
		total,
		subTotal,
		taxAmount,
		refunds
	}
}) => {
	const payments = [
		...giftCardPayments.map(payment => (
			<Flex key={payment.id} $justifyContent="space-between">
				<Title>BIGGBY Card #{payment.cardNumber}</Title>
				<Amount>${centsToMoney(payment.amount)}</Amount>
			</Flex>
		)),
		...creditCardPayments.map(payment => (
			<Flex key={payment.id} $justifyContent="space-between">
				<Title>Credit Card: {payment.identifier}</Title>
				<Amount>${centsToMoney(payment.amount)}</Amount>
			</Flex>
		))
	];

	return (
		<Flex $flexDirection="column" $rowGap="20px">
			<Status status={status} time={time} />
			<Details
				id={id}
				pickupLocation={pickupLocation}
				pickupName={pickupName}
				timePlaced={timePlaced}
				status={status}
				storeId={storeId}
			/>
			{pointsEarned > 0 && <Rewards pointsEarned={pointsEarned} />}
			<Items items={items} refunds={refunds} status={status.status} />
			{status.status === 'ORDER_REFUND_PROCESSED' ? (
				<RefundAmounts total={total} payments={payments} />
			) : (
				<>
					<Totals
						total={total}
						subTotal={subTotal}
						taxAmount={taxAmount}
					/>
					<Payments payments={payments} />
				</>
			)}

			{status.status !== 'ORDER_REFUND_PROCESSED' &&
				refunds.length > 0 && <RefundItems refunds={refunds} />}
		</Flex>
	);
};

const Title = styled.div`
	font-weight: 500;
	font-size: 20px;
	color: #222222;
`;

const Amount = styled.div`
	font-weight: 500;
	font-size: 20px;
	color: #575757;
`;
